import { useRef, useEffect } from 'react';
import { usePriorityScrollableContent } from '..';

export const useRegisterPriorityScrollableContentRef = () => {
  const { registerPriorityScrollableContentRef } =
    usePriorityScrollableContent();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const unregister = registerPriorityScrollableContentRef(ref);
    return unregister; // Cleanup happens automatically
  }, [registerPriorityScrollableContentRef]);

  return ref;
};
